import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';

@Component({
  selector: 'app-bac-media',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  providers: [TranslateService, TranslatePipe],
  templateUrl: './bac-media.component.html',
  styleUrl: './bac-media.component.css',
})
export class BacMediaComponent {}
